import React, { useState, useEffect } from "react";
import Title from "../Title/Title";
import Button from "../Button/Button";
import Paragraph from "../Paragraph/Paragraph";
import styles from "./Result.module.scss";
import classNames from "classnames";
import { SITE_URL, GO_URL } from "../../state/consts";
import { IconButton, Snackbar } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";

import {
  FacebookShareButton,
  WhatsappShareButton,
  TelegramShareButton,
} from "react-share";

import { FacebookIcon, WhatsappIcon, TelegramIcon } from "react-share";

function Result({
  score,
  title,
  text,
  imageSrc,
  posterContainer,
  optionsContainer,
  handlerBack,
}) {
  const [offset, setOffset] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setOffset(true);
      } else {
        setOffset(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const ImageURL = SITE_URL + imageSrc;

  const handleClick = (e) => {
    e.preventDefault();
    window.open(GO_URL);
  };

  // кнопка скопировать
  const [open, setOpen] = useState(false);

  const testClick = () => {
    setOpen(true);
    navigator.clipboard.writeText(window.location.toString());
  };

  return (
    <>
      <div className={posterContainer}>
        <img src={imageSrc} className={styles.image} alt="" />
      </div>
      <div className={classNames(optionsContainer, styles.before)}>
        <div
          className={classNames({
            [styles.resultPosterContainer]: true,
            [styles.onScrollOption]: offset,
          })}
        >
          <div className={styles.contentWrapper}>
            <div className={styles.score}>{score}</div>
            <Title value={title} />
            {text}
            <Paragraph value="Let's get to know each other. Tell us a little about yourself so that we can share with you the news of the service and pick up only the most relevant promotions for you." />
          </div>
          <div className={styles.buttonBox}>
            <Button
              value="Fill in the form"
              onClick={handleClick}
              id="goToForm"
            />
            <Button
              value="Try again"
              className={styles.outline}
              onClick={handlerBack}
              id="refresh"
            />
          </div>

          <div
            className={classNames(styles.contentWrapper, styles.socialWrapper)}
          >
            <Paragraph value="Share your result" />
            <div className={styles.social}>
              <FacebookShareButton
                url={SITE_URL}
                title="Only one statement is true. Now let's find out if you can tell the difference between reality and imagination."
                image={ImageURL}
                hashtag="#Maxim"
                id="facebook"
              >
                <FacebookIcon
                  size={48}
                  round={true}
                  className={classNames(styles.icon, styles.facebook)}
                />
              </FacebookShareButton>

              <WhatsappShareButton
                url={SITE_URL}
                title="Only one statement is true. Now let's find out if you can tell the difference between reality and imagination."
                image={ImageURL}
                id="whatsapp"
              >
                <WhatsappIcon
                  size={48}
                  round={true}
                  className={classNames(styles.icon, styles.whatsapp)}
                />
              </WhatsappShareButton>

              <TelegramShareButton
                url={SITE_URL}
                title="Only one statement is true. Now let's find out if you can tell the difference between reality and imagination."
                image={ImageURL}
                id="telegram"
              >
                <TelegramIcon
                  size={48}
                  round={true}
                  className={classNames(styles.icon, styles.telegram)}
                />
              </TelegramShareButton>

              <div id="sharelink">
                <IconButton
                  onClick={testClick}
                  color="primary"
                  className={styles.share}
                >
                  <ShareIcon />
                </IconButton>
                <Snackbar
                  message="Copied to clipboard"
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  autoHideDuration={1000}
                  onClose={() => setOpen(false)}
                  open={open}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Result;
